<template>
  <div class="theme-default">
    <Navbar />
    <LeftSidebar />
    <main class="MasterLayout__main">
      <slot />
    </main>
    <Footer />
  </div>
</template>

<style lang="scss"></style>

<script>
import $ from "jquery";
import { Header, Navbar, LeftSidebar, Footer } from "@/components/partials";
// import image from "../../assets/logo.svg";

// import YourLogo from "./../../../public/assets/images/images/logo";
// import "./../public/assets/css/login.css";
// import $ from "jquery";
export default {
  components: { Header, Navbar, LeftSidebar, Footer },
  data: () => ({
    //
  }),
  methods: {
    //
  },
  computed: {
    // logo() {
    //   return image;
    // },
  },
  mounted: function () {
    // $("#loading__container").fadeOut(2000);
    //console.log('Master layout component mounted.');
  },
};
</script>
